export default __webpack_public_path__ + "static/media/ITA_background_13.74f01ce3.jpg";